@use '@fukuri-admins/ui/layout' as *;

.trigger {
  // asChildで子コンポーネント（Button等）にスタイルを委譲するため、
  // 最小限のスタイルのみ定義
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.content {
  z-index: 99999;
  min-width: 112px;
  overflow: hidden;
  border-radius: borderRadius('lg');
  border: 1px solid border('Tertiary');
  background-color: background('Primary');
  color: text('High');
  padding: spacing('4');
  @include elevation('3');

  // アニメーション
  &[data-state='open'] {
    animation:
      fadeIn 0.15s ease-out,
      zoomIn 0.15s ease-out;
  }

  &[data-state='closed'] {
    animation:
      fadeOut 0.15s ease-in,
      zoomOut 0.15s ease-in;
  }

  // スライドアニメーション
  &[data-side='bottom'] {
    animation:
      fadeIn 0.15s ease-out,
      zoomIn 0.15s ease-out,
      slideInFromTop 0.15s ease-out;
  }

  &[data-side='left'] {
    animation:
      fadeIn 0.15s ease-out,
      zoomIn 0.15s ease-out,
      slideInFromRight 0.15s ease-out;
  }

  &[data-side='right'] {
    animation:
      fadeIn 0.15s ease-out,
      zoomIn 0.15s ease-out,
      slideInFromLeft 0.15s ease-out;
  }

  &[data-side='top'] {
    animation:
      fadeIn 0.15s ease-out,
      zoomIn 0.15s ease-out,
      slideInFromBottom 0.15s ease-out;
  }

  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}

.label {
  padding: spacing('6') spacing('8');
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: text('Middle');
}

.item {
  position: relative;
  display: flex;
  width: 100%;
  cursor: default;
  user-select: none;
  align-items: center;
  border-radius: borderRadius('lg');
  padding: spacing('6') spacing('8');
  font-size: 14px;
  line-height: 20px;
  outline: none;
  transition: background-color 0.1s ease;

  &:focus,
  &[data-highlighted] {
    background-color: background('Secondary');
    color: text('High');
  }

  &[data-disabled] {
    pointer-events: none;
    opacity: 0.5;
  }
}

.separator {
  margin: spacing('4') calc(spacing('4') * -1);
  height: 1px;
  background-color: border('Tertiary');
}

// アニメーションキーフレーム
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes zoomIn {
  from {
    transform: scale(0.95);
  }
  to {
    transform: scale(1);
  }
}

@keyframes zoomOut {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0.95);
  }
}

@keyframes slideInFromTop {
  from {
    transform: translateY(-8px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slideInFromRight {
  from {
    transform: translateX(8px);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideInFromLeft {
  from {
    transform: translateX(-8px);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes slideInFromBottom {
  from {
    transform: translateY(8px);
  }
  to {
    transform: translateY(0);
  }
}
